import { create } from 'zustand';
import MuvikaService from './../services/muvika';
import messageStore from './message';
import accountStore from './account';

const initialState = {
  appStatus: null,
  playerStatus: "stopped",
  isUpdateable: false,
  isForceUpdate: false,
  isMessage: false,
  messageTitle: null,
  message: null
};

const statusStore = create((set, get) => ({
  ...initialState,
  reset: () => { 
    set(initialState);
  },
  clearMessage: () => { 
    set({ isMessage: false, messageTitle: null, message: null });
  },
  clearUpdate: () => { 
    set({ isUpdateable: false, isForceUpdate: false });
  },
  setAppStatus: (sessionToken, appStatus) => {
    set({ appStatus: appStatus });
    get().sendStatusReport(sessionToken);
  },
  setPlayerStatus: (sessionToken, playerStatus) => {
    set({ playerStatus: playerStatus });
    get().sendStatusReport(sessionToken);
  },
  sendStatusReport: (sessionToken) => {
    let appStatus = get().appStatus;
    let playerStatus = get().playerStatus;
    if (appStatus && playerStatus) {
      MuvikaService.statusReport(sessionToken, appStatus, playerStatus)
        .then(function (res) {
          //console.log(res);
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            let serverDate = new Date(res.data.data.server_time);
            let dateNow = new Date();
            console.log(dateNow);
            let diff = serverDate.getTime() - dateNow.getTime();
            let minutesDiff = (diff / (1000 * 60)).toFixed(1);
            console.log("diff: " + minutesDiff);
            accountStore.setState({ timeDiff: minutesDiff });
            let command = res.data.data.command;
            if (command) {
              let commandCmd = command.cmd;
              switch (commandCmd) {
                case "show_msg":
                  set({ isMessage: true, messageTitle: command.title, message: command.msg });
                  break;
                case "sw_update":
                  set({ isUpdateable: true, isForceUpdate: command.sw_release.force_update });
                  break;
              }
            }
          }
        })
        .catch(function () { });
    }
  }
}));

export default statusStore;